import { Alpine } from "./alpine.js";

import "./appearance";
import "./collapsible";
import "./favorites";
import "./hotkeys";
import "./nav";
import "./search";
import "./scroll-anchor";
import "./scroll-position";

Alpine.start();
